import { Translate } from 'react-translate.ts';

export default function ContactButton() {
    return (
        <div data-test="contact-nav-link">
            <Translate>fe.nav.contact</Translate>
        </div>
    );
}
